export const homeImgLinkSliderData = [
  {
    title: 'Percebendo a queda de cabelo?',
    imageSrc: '/landings/products/dermatology/minoxidil_spray.webp',
    href: '/calvicie'
  },
  {
    title: 'Desafios no rendimento sexual?',
    imageSrc: '/landings/dermatology/men_hug.webp',
    href: '/saude-sexual'
  },
  {
    title: 'Sua pele precisa de cuidados?',
    imageSrc: '/landings/dermatology/black_man_face_hand.webp',
    href: '/dermatologia'
  }
]

export const homeImgLinkSliderDataSmartfit = [
  {
    title: 'Percebendo a queda de cabelo?',
    imageSrc: '/landings/products/dermatology/minoxidil_spray.webp',
    href: '/consultar'
  },
  {
    title: 'Desafios no rendimento sexual?',
    imageSrc: '/landings/dermatology/men_hug.webp',
    href: '/consultar'
  },
  {
    title: 'Sua pele precisa de cuidados?',
    imageSrc: '/landings/dermatology/black_man_face_hand.webp',
    href: '/consultar'
  }
]
